export default __webpack_public_path__ + "static/media/MainLogo.6eb33c63.png";